module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 11.24184e94.png";